module.exports = __webpack_public_path__ + "media/images/icons/powered_by_stripe-1d146ea9035b6d161aea057c5fb71e2e.svg";